import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';

// Crypto Redux States
import { ConfigTaskTypes } from './actionTypes';
import {
  getConfigTaskSuccess,
  getConfigTaskFail,
  addConfigTaskFail,
  addConfigTaskSuccess,
  deleteConfigTaskSuccess,
  deleteConfigTaskFail,
  updateConfigTaskFail,
  updateConfigTaskSuccess,
} from './actions';

import apiFetch from '../../fetch';
import * as url from '../../helpers/url_helper';
import { addApiListSuccessful } from '../apiList/actions';

export const fetchConfigTask = async (data: any) => {
  const { sizePerPage, page } = data?.pagination ?? {
    sizePerPage: 50,
    page: 1,
  };

  let textClient = '';
  let textTareaId = '';

  if (data.data) {
    textClient = data.data['Search Client ID'];
    textTareaId = data.data['Search Task ID'];
  }

  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  const path = url.API_URL;
  const query = `query{
    ConfigTareasPaginated(Pagination:{
      sizePage:${sizePerPage},
      actualPage:${page}
      },
      filter:{
        ${textClient ? `clienteId: ${textClient}` : ''}
        ${textTareaId ? `tareaId: ${textTareaId}` : ''}
    },
    FilterEmpresaID:{
      ${user.id ? `userId: ${user.id}` : ''}
    }
      )
    {
      configTaskData{
        id
        tareaId
        empresa
        clienteId
        repetirCada
        enabled
        workflow
      },
      CountItems
    }
  }`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.ConfigTareasPaginated;
};

function* getConfigTaskSaga(data: any) {
  try {
    const response: Promise<any> = yield call(fetchConfigTask, data.payload);
    yield put(getConfigTaskSuccess(response));
  } catch (error) {
    yield put(getConfigTaskFail(error));
  }
}

export const addConfigTaskList = async ({ payload }: any) => {
  const path = url.API_URL;
  const { empresa, clienteId, tareaId, repetirCada, enabled, workflow } =
    payload.configTaskAdd.ConfigTask;
  const query = `mutation{
    createConfigTareas(
      ConfigTareas:{
        empresa: ${empresa},
        clienteId: ${clienteId},
        tareaId: ${tareaId},
        repetirCada: "${repetirCada}",
        enabled: ${enabled},
        workflow: ${workflow}
      
    }){
      empresa
      clienteId
      tareaId
      repetirCada
      enabled
      workflow
    }
  }`;

  const respon = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return respon.data.createConfigTareas;
};

function* addConfigTaskSaga(configTask: any) {
  const { pagination } = configTask.payload.configTaskAdd;
  try {
    const response: Promise<any> = yield call(addConfigTaskList, configTask);

    yield put(addConfigTaskSuccess(response));
    const response2: Promise<any> = yield call(fetchConfigTask, { pagination });
    yield put(getConfigTaskSuccess(response2));
  } catch (error) {
    yield put(addConfigTaskFail(error));
  }
}

export const deleteConfigTaskList = async (data: any) => {
  const path = url.API_URL;
  const { id } = data;
  const query = `mutation {
    deleteConfigTareas(
      ConfigTareas:{
        id: ${id}
      }){
      id
    }
  }`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.deleteConfigTareas;
};

function* deleteConfigTaskSaga({ payload }: any) {
  const { id, pagination } = payload;
  try {
    const response: Promise<any> = yield call(deleteConfigTaskList, id);
    yield put(deleteConfigTaskSuccess(response));
    const response2: Promise<any> = yield call(fetchConfigTask, { pagination });
    yield put(getConfigTaskSuccess(response2));
  } catch (error) {
    yield put(deleteConfigTaskFail(error));
  }
}

function* updateConfigTaskList(action: any): any {
  const path = url.API_URL;
  const pagination = action.payload.configTask.pagination;
  const { id, empresa, clienteId, tareaId, repetirCada, enabled, workflow } =
    action.payload.configTask.ConfigTask;

  const query = `mutation{
    updateConfigTareas(
      ConfigTareas:{
        id: ${id}
        empresa: ${empresa},
        clienteId: ${clienteId},
        tareaId: ${tareaId},
        repetirCada: "${repetirCada}",
        enabled: ${enabled},
        workflow: ${workflow}
      }){
        id
      }
  }`;

  try {
    const opts = {
      authRequired: false,
      body: {
        query,
      },
      method: 'POST',
    };

    const resp: any = yield call(apiFetch, path, opts);

    const response: Promise<any> = yield call(fetchConfigTask, {
      pagination,
      data: action.payload.configTask.data,
    });
    yield put(getConfigTaskSuccess(response));
  } catch (error) {
    yield put(updateConfigTaskFail(error));
  }
}

function* ConfigTaskSaga() {
  yield takeEvery(ConfigTaskTypes.GET_CONFIG_TASK, getConfigTaskSaga);
  yield takeEvery(ConfigTaskTypes.ADD_CONFIG_TASK, addConfigTaskSaga);
  yield takeEvery(ConfigTaskTypes.DELETE_CONFIG_TASK, deleteConfigTaskSaga);
  yield takeLatest(ConfigTaskTypes.UPDATE_CONFIG_TASK, updateConfigTaskList);
}

export default ConfigTaskSaga;
